<template>
  <div v-show="activePanelKey" class="quickbi-panel-shell h_100 w_100">
    <template v-for="panel in panels">
      <div
        v-if="mountedMap[panel.key]"
        :key="panel.key"
        v-show="activePanelKey === panel.key"
        class="quickbi-panel h_100 w_100"
      >
        <component :is="panel.component" v-bind="panel.props" />
      </div>
    </template>
  </div>
</template>

<script>
import QuickBIEmbedJSSdk from '@/views/report/component/QuickBIEmbedJSSdk.vue'
import XiaoQQueryEmbed from '@/views/report/component/XiaoQQueryEmbed.vue'
import {
  QUICKBI_PANEL_KEYS,
  createInitialMountedMap,
  getQuickBIPanelKeyByRoute,
} from '@/utils/quickBIPanelCache'

export default {
  name: 'QuickBIPanelShell',
  components: {
    QuickBIEmbedJSSdk,
    XiaoQQueryEmbed,
  },
  data() {
    return {
      activePanelKey: null,
      mountedMap: createInitialMountedMap(),
      panels: [
        {
          key: QUICKBI_PANEL_KEYS.SELF_SERVICE_ANALYSIS,
          component: QuickBIEmbedJSSdk,
          props: {
            embedPage: 'view',
            panelKey: QUICKBI_PANEL_KEYS.SELF_SERVICE_ANALYSIS,
          },
        },
        {
          key: QUICKBI_PANEL_KEYS.SELF_SERVICE_DOWNLOAD,
          component: QuickBIEmbedJSSdk,
          props: {
            embedPage: 'downloadList',
            panelKey: QUICKBI_PANEL_KEYS.SELF_SERVICE_DOWNLOAD,
          },
        },
        {
          key: QUICKBI_PANEL_KEYS.XIAO_Q_REPORT,
          component: QuickBIEmbedJSSdk,
          props: {
            embedPage: 'copilotPageQReport',
            panelKey: QUICKBI_PANEL_KEYS.XIAO_Q_REPORT,
          },
        },
        {
          key: QUICKBI_PANEL_KEYS.XIAO_Q_QUERY,
          component: XiaoQQueryEmbed,
          props: {},
        },
      ],
    }
  },
  watch: {
    '$route'(route) {
      this.syncFromRoute(route)
    },
    '$store.state.user.id'(newId, oldId) {
      if (oldId != null && newId !== oldId) {
        this.resetPanels()
      }
    },
  },
  mounted() {
    this.syncFromRoute(this.$route)
  },
  methods: {
    syncFromRoute(route) {
      const panelKey = getQuickBIPanelKeyByRoute(route)
      if (panelKey) {
        this.$set(this.mountedMap, panelKey, true)
        this.activePanelKey = panelKey
        return
      }
      this.activePanelKey = null
    },
    resetPanels() {
      this.activePanelKey = null
      this.mountedMap = createInitialMountedMap()
    },
  },
}
</script>

<style scoped>
.quickbi-panel-shell {
  position: relative;
  overflow: hidden;
}

.quickbi-panel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
